import { getConversionInputStores } from "@/app/(application)/(normal)/create/components/input/ttv/getConversionInputStores";
import { isAudioInputFile } from "@/utils/audioInput/is/isAudioInputFile";

export const getConversionInputChoices = () =>
  getConversionInputStores().flatMap((store, index) => {
    const input = store.getState();
    if (input.selectedFileCover === null) {
      return [];
    }
    return [
      {
        index,
        label:
          isAudioInputFile(input) ?
            (input.selectedFileCover.selectedSound?.filename ??
            "Uploading vocal")
          : "Selected cover",
        soundId:
          isAudioInputFile(input) ?
            (input.selectedFileCover.selectedSound?.id ?? null)
          : null,
      },
    ];
  });
